import camelCase from 'lodash/camelCase';
import { InstallableModule, InstallableWidget, Module } from '../../types/modules';

export const getInstallableWidgets = (
  widgetConfigs,
  installableModules: InstallableModule[]
): InstallableWidget[] => {
  return installableModules
    .map(module => {
      const { moduleName } = module;
      const widgetConfig = widgetConfigs[camelCase(moduleName)];
      if (!widgetConfig) {
        return null;
      }
      const { widgetCard } = widgetConfig;
      return {
        module,
        widgetCard,
      };
    })
    .filter(Boolean) as InstallableWidget[];
};

export const filterAlreadyInstalledAndCoreRestrictedModules = (
  installableModules: InstallableModule[],
  installedModules: Module[]
) => {
  const installedModuleCounts = installedModules.reduce(
    (acc, module) => ({
      ...acc,
      [module.name]: (acc[module.name] || 0) + 1,
    }),
    {} as Record<string, number>
  );

  return installableModules
    .map(module => {
      const { restrict, moduleName, limit } = module;
      if (restrict && restrict.permitted === false) {
        return null;
      }
      const installedCount = installedModuleCounts[moduleName] ?? 0;
      if (installedCount >= limit) {
        return null;
      }
      return module;
    })
    .filter(Boolean) as InstallableModule[];
};
